import { isUnansweredAnswer } from '@educaplay/store/utils/functions';
import { useSelector } from 'react-redux'
import { GAME_MODES, MAPA_SOUNDS } from '../../utils/constants';
import { Button, COLORS, IconButton, TYPE_QUESTIONS, useGameSounds, useMediaQuery, useTranslate } from '@educaplay/core';
import classes from './NavButtons.module.scss';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { ContinueIcon, FinishIcon, NextIcon, StartIcon } from "../../utils/Icons";
import { useEffect } from 'react';
import { useState } from 'react';
import useNavigationQuestion from '../../hooks/useNavigationQuestion';

export default function NavButtons(props) {

    const { nextButtonHandler, mapCurrentQuestion, passScreenHandler, isInfoScreenActive, isInputOpen } = props;
    const screenId = useSelector(state => state.game.questions[state.game.currentIndex].screenId);  
    const questions = useSelector(state => state.game.questions).filter(question => question.screenId === screenId);
    const allQuestions = useSelector(state => state.game.questions);
    const lastScreenRealIndex = allQuestions.findIndex(question => question.id === questions[questions.length - 1].id);
    const isAllScreenPointsVisited = questions.every(question => !isUnansweredAnswer(question.answer,{examMode: false}) && question.checkAnswer(question.answer));
    const currentQuestion = useSelector(state => state.game.questions[state.game.currentIndex]);
    const isMobileTablet = (useMediaQuery("(min-width: 1280px)"));
    const typeScreen = questions[0].mode;
    const gameSound = useGameSounds();
    const [hasInteraction, setHasInteraction] = useState(false);
    const isSelectionScreen = currentQuestion.type === TYPE_QUESTIONS.Selection && currentQuestion.mode === GAME_MODES.PLAY;
    const [hiddenButton, setHiddenButton] = useState(false);  
    const {enablePassQuestion} = useNavigationQuestion();  
    if (mapCurrentQuestion !== null && !hasInteraction) setHasInteraction(true);


    const t = useTranslate();
    const disabled = isAllScreenPointsVisited && typeScreen !== GAME_MODES.EXPLORE;


    const hasMoreScreens = () => {
        return allQuestions.length - 1 === lastScreenRealIndex ? false : true;
    }


    useEffect(() => {

        if (isAllScreenPointsVisited && currentQuestion.mode === GAME_MODES.EXPLORE) {
            gameSound.play(MAPA_SOUNDS.ACTIVATE);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAllScreenPointsVisited])

    useEffect(() => {
        const hiddenButtonHandler = () => {  
            setHiddenButton(true);
        }  

        document.addEventListener('hiddenButton', hiddenButtonHandler);

        return () => {
            document.removeEventListener('hiddenButton', hiddenButtonHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
        setHiddenButton(false);
    },[currentQuestion.screenId])

    return (
        <div className={classes.buttonsNavContainer}>
            <motion.div initial={{ y: "150%" }} animate={{ y: "0%" }} transition={{ delay: 1.2 }} className={classes.Pager}>

                {(!isAllScreenPointsVisited && !hasInteraction && !isSelectionScreen) && (
                    <>
                        {isMobileTablet && (<Button type={"button"}
                            icon={<StartIcon color={COLORS.primaryDark1} />}
                            className={classes.sendButtonDesktop}
                            disabled={disabled}
                            onClick={()=>{nextButtonHandler(enablePassQuestion)}}
                        >
                            {t('common.main.start')}
                        </Button>)}

                        {!isMobileTablet && (<IconButton
                            icon={<StartIcon color={COLORS.primaryDark1} />}
                            className={classes.sendButton}
                            onClick={()=>{nextButtonHandler(enablePassQuestion)}}
                        />)}
                    </>
                )}

                {((!isAllScreenPointsVisited && hasInteraction) || (!isAllScreenPointsVisited && !hasInteraction && isSelectionScreen && questions.length > 1)) && (
                    !hiddenButton && <button
                        disabled={disabled}
                        type="button"
                        className={clsx(classes.buttonPager, classes.buttonPager__next, ((isInfoScreenActive && currentQuestion.type !== TYPE_QUESTIONS.Text) || (isInfoScreenActive && currentQuestion.type === TYPE_QUESTIONS.Text && !isInputOpen)) && classes.buttonPager__next__active)} onClick={()=>{nextButtonHandler(enablePassQuestion)}}>
                        <span className={classes.buttonPager__icon}>
                            <NextIcon color={COLORS.primary} />
                        </span>
                        <div className={classes.buttonPager__text}>
                            {t('specific.next')}
                        </div>
                    </button>
                )}
                {(isAllScreenPointsVisited && isMobileTablet && typeScreen === GAME_MODES.EXPLORE) && (
                    <div>
                        <Button type={"button"}
                            icon={hasMoreScreens() ? <ContinueIcon /> : <FinishIcon />}
                            className={classes.sendButtonDesktop}
                            onClick={passScreenHandler}
                        >
                            {hasMoreScreens() ? t('specific.continue') : t('specific.finish')}
                        </Button>
                    </div>
                )}

                {(isAllScreenPointsVisited && !isMobileTablet && typeScreen === GAME_MODES.EXPLORE) && (
                    <IconButton
                        icon={hasMoreScreens() ? <ContinueIcon /> : <FinishIcon />}
                        className={classes.sendButton}
                        onClick={passScreenHandler}
                    />
                )}
            </motion.div>
        </div>
    )

}